/**
 * @file Registre des 7 comportements d'armes : l'arme est choisie par la donnee WeaponDef.behavior, jamais par un if sur son nom.
 */
import type { WeaponBehavior } from '@shared/enums';
import { Registry } from '../../util/Registry';
import type { WeaponBehaviorModule } from '../WeaponBehavior';
import { blastSniperBehavior } from './blastSniper';
import { explosiveBehavior } from './explosive';
import { laserBehavior } from './laser';
import { missileBehavior } from './missile';
import { pierceBehavior } from './pierce';
import { shotgunBehavior } from './shotgun';
import { singleBehavior } from './single';

export const createBehaviorRegistry = (): Registry<WeaponBehavior, WeaponBehaviorModule> =>
  new Registry<WeaponBehavior, WeaponBehaviorModule>('WeaponBehavior')
    .register('single', singleBehavior)
    .register('pierce', pierceBehavior)
    .register('shotgun', shotgunBehavior)
    .register('explosive', explosiveBehavior)
    .register('laser', laserBehavior)
    .register('missile', missileBehavior)
    .register('blastSniper', blastSniperBehavior);

/** Registre partage (les modules sont sans etat). Ajouter un comportement = un module + une ligne ici + l'union WeaponBehavior. */
export const BEHAVIORS = createBehaviorRegistry();
